import React, { FC } from "react"
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide } from "swiper/react"
import { Navigation, Pagination, EffectFade } from "swiper"
import { useSwiperRef } from "@hooks/useSwiperRef"
import { Container, Prev, Next } from "../styles"

import { ContentSlidesProps } from "./types"
import {
    ContentContainer,
    ContentSlidesWrapper,
    Nav,
    StyledSwiper,
    StyledImage,
    PaginationWrapper
} from "./styles"

// TODO this is also being imported at MailLayout, so maybe this is redundant
// Import Swiper styles
// eslint-disable-next-line import/no-unresolved
import "swiper/css/bundle"

const ContentSlides: FC<ContentSlidesProps> = ({
    content,
    images
}) => {
    const [nextEl, nextElRef] = useSwiperRef<HTMLDivElement>()
    const [prevEl, prevElRef] = useSwiperRef<HTMLDivElement>()
    const [paginationEl, paginationElRef] = useSwiperRef<HTMLDivElement>()

    return <ContentSlidesWrapper>
        <StyledSwiper
            modules={[Navigation, Pagination, EffectFade]}
            navigation={{
                nextEl,
                prevEl
            }}
            pagination={{
                el: paginationEl
            }}
            effect="fade"
            slidesPerView="auto"
            slidesPerGroup={1}
            spaceBetween={0}
            grabCursor
            preloadImages={false}
            breakpoints={{
                0: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                }
            }}
        >
            {images?.map((image, index) => {
                // eslint-disable-next-line react/no-array-index-key
                return <SwiperSlide key={index}>
                    <StyledImage>
                        {image}
                    </StyledImage>
                </SwiperSlide>
            })}
        </StyledSwiper>
        <Container style={{ position: "relative", pointerEvents: "none" }}>
            <ContentContainer>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </ContentContainer>
            <Nav>
                <PaginationWrapper ref={paginationElRef} />
                <Prev ref={prevElRef} />
                <Next ref={nextElRef} />
            </Nav>
        </Container>
    </ContentSlidesWrapper>
}

export default ContentSlides
